module.exports = __webpack_public_path__ + "img/cartillas-silabas-trabadas.45f0e08d.png";